import React, { FunctionComponent } from 'react';

import styles from './PostBox.module.scss';
import TiktokPostCard from '../TiktokPostCard';
import TwitterTweetCard from '../TwitterTweetCard';
import InstagramPostCard from '../InstagramPostCard';
import YouTubeVideoCard from '../YouTubeVideoCard';
import LinkedinPostCard from '../LinkedinPostCard';

interface Props {
  data: any;
  columnType: 'negative' | 'positive' | 'neutral' | 'all';
  isTemplate: boolean;
  compId: string;
  isReport: boolean;
  hideSliderFormPostCard?: boolean;
  showFavorite?: boolean;
  tabName?: string;
  postDetailsUrl?: string;
}

const PostBox: FunctionComponent<Props> = ({
  data,
  columnType,
  isTemplate,
  compId,
  isReport,
  tabName,
  hideSliderFormPostCard,
  showFavorite,
  postDetailsUrl,
}) => {
  const RenderPostCard = () => {
    if (data?.icon === 'Tiktok')
      return (
        <TiktokPostCard
          {...{ data, columnType, isTemplate, compId, isReport }}
          commentsActionRow={tabName === 'COMMENTS'}
          withoutSlider={tabName === 'COMMENTS' || hideSliderFormPostCard}
          showFavorite={showFavorite}
          isContentClickable={tabName !== 'COMMENTS'}
        />
      );
    if (data?.icon === 'Twitter')
      return (
        <TwitterTweetCard
          data={data}
          isContentClickable
          isReport={isReport}
          compId={compId}
          tweetType={columnType}
          detailsUrl={postDetailsUrl}
        />
      );
    if (data?.icon === 'Instagram')
      return (
        <InstagramPostCard
          data={data}
          isContentClickable={tabName !== 'COMMENTS' && tabName !== 'REPLIES'}
          isPost={tabName !== 'COMMENTS' && tabName !== 'REPLIES'}
          isReport={isReport}
          compId={compId}
          post_type={columnType}
          showRegrab={tabName === 'COMMENTS'}
        />
      );

    if (data?.icon === 'Youtube' || data?.platform === 'Youtube')
      return (
        <YouTubeVideoCard
          post_type={columnType}
          data={data}
          isContentClickable={tabName !== 'COMMENTS'}
          isReport={isReport}
          isComment={tabName === 'COMMENTS'}
        />
      );

    if (data?.icon === 'Linkedin')
      return (
        <LinkedinPostCard
          post_type={columnType}
          data={data}
          isReport={isReport}
          isContentClickable={tabName !== 'COMMENTS'}
        />
      );
  };
  return (
    <div className={styles.PostBox}>
      <RenderPostCard />
    </div>
  );
};

export default PostBox;
